import THDStorageUtils, { LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';
import { FALLBACK_USER_ID, PAGE_TYPES } from '../components/MagicApronAssistant/constants';

export const getMcvisID = () => {
  return typeof window !== 'undefined'
    ? window.THDCustomer?.default?.mcvisID || FALLBACK_USER_ID : FALLBACK_USER_ID;
};

export const getSvocId = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.svocID || null : null;
};

export const getUserName = () => {
  return typeof window !== 'undefined' ? window.THDCustomer?.default?.name || null : null;
};

export const getParentPagePath = () => {
  return typeof window !== 'undefined'
    ? new URL(window.parent.document.documentURI).pathname
    : '';
};

const getPageTypeForApi = (pathSegment) => {
  switch (pathSegment) {
  case 'c':
    return 'Content';
  case 'p':
    return PAGE_TYPES.PIP;
  case 's':
  case 'b':
    return PAGE_TYPES.PLP;
  case '':
    return 'Home';
  default:
    return 'Home';
  }
};

const getPageTypeForStandard = (pathSegment) => {
  switch (pathSegment) {
  case 'c':
    return PAGE_TYPES.CONTENT;
  case 'p':
    return PAGE_TYPES.PIP;
  case 's':
    return PAGE_TYPES.SEARCH;
  case 'b':
    return PAGE_TYPES.BROWSE;
  case '':
    return PAGE_TYPES.HOME;
  default:
    return PAGE_TYPES.UNKNOWN;
  }
};

const determinePageTypeFromPath = (pathSegment, secondSegment, api) => {
  if (pathSegment === 'p' && secondSegment === 'sets') {
    return PAGE_TYPES.BIP;
  }

  return api ? getPageTypeForApi(pathSegment) : getPageTypeForStandard(pathSegment);
};

export const getPageType = (api = false) => {
  const pathArray = getParentPagePath().split('/');
  return determinePageTypeFromPath(pathArray[1], pathArray[2], api);
};

export const getItemId = () => {
  if (getPageType() !== PAGE_TYPES.PIP) return null;

  return getParentPagePath().split('/').at(-1);
};

export const getRecentSearchTerms = () => {

  try {
    const history = THDStorageUtils.get(LOCAL_STORAGE, { key: 'header_search_history' });
    if (!history || history === 'undefined') return [];
    return JSON.parse(history).map((term) => {
      try {
        return decodeURIComponent(term.keyword);
      } catch {
        return term.keyword;
      }
    });

  } catch (error) {
    // eslint-disable-next-line no-console
    console.error({
      message: `Error occurred while accessing local storage - ${'header_search_history'}`,
      error
    });
    return [];
  }
};
